import React, { useEffect, useState } from "react";
import Banner from "../components/banner/banner";
import WebProfileCard from "../components/webProfileCard/webProfileCard";
import TopNavbar from "../components/TopNavbar/TopNavbar";
import Navbar from "../components/navbar/navbar";
import Footer from "../components/footer/footer";
import axios from "axios";

const Home = () => {
  const [maleProfiles, setMaleProfiles] = useState([]);
  const [femaleProfiles, setFemaleProfiles] = useState([]);

  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (fetched) return;

    axios.get('https://kovaikongunadumatrimony.com/kkm_backend/public/api/web-recent-profile')
      .then(response => {
        if (response.data.status) {
          setMaleProfiles(response.data.male_profiles);
          setFemaleProfiles(response.data.female_profiles);
          setFetched(true);
        }
      });
  }, [fetched]);

  return (
    <>
      <TopNavbar />
      <Navbar />
      <Banner />
      <WebProfileCard
        memberHeading={"New Members"}
        showStatus={true}
        Userdata={femaleProfiles} />
      <WebProfileCard Userdata={maleProfiles} />
      <Footer />
    </>
  );
};

export default Home;
